import { Empty } from "antd";
import { FC } from "react";
import { Styled, TabStyled } from "./styled";
import { ReactGrid } from "@silevis/reactgrid";
import useExcel, { IProps } from "./hook";
import { CustomCellTemplate } from "./Cells/CustomCellTemplate";
import { IndexCellTemplate } from "./Cells/IndexCellTemplate";
import TabPane from "antd/lib/tabs/TabPane";
const SPACE_FOR_RESIZE_BTN = 47;

const ExcelLayout = (props: ReturnType<typeof useExcel>) => {
  const {
    columns,
    rows,
    handleColumnResized,
    sheets,
    handleChooseSheet,
    isCSV,
  } = props;

  return (
    <Styled>
      <div
        style={{
          width: "100%",
          height: "calc(100% - 40px)",
          overflow: "auto",
        }}
      >
        <div
          style={{
            height: "100%",
          }}
        >
          {!rows?.length && !!sheets?.length && (
            <div
              className="d-flex justify-center align-item-center"
              style={{
                height: "100%",
                width: "100%",
              }}
            >
              <Empty />
            </div>
          )}
          <ReactGrid
            columns={columns}
            rows={rows}
            enableRangeSelection={true}
            enableColumnSelection={true}
            enableRowSelection={true}
            stickyTopRows={1}
            stickyLeftColumns={1}
            onColumnResized={handleColumnResized}
            customCellTemplates={{
              custom: new CustomCellTemplate(),
              index: new IndexCellTemplate(),
            }}
          />
        </div>
      </div>
      {!isCSV && (
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            width: "",
          }}
        >
          <div
            style={{
              width: `calc(100% - ${SPACE_FOR_RESIZE_BTN}px)`,
            }}
          >
            <TabStyled onChange={handleChooseSheet}>
              {sheets.map((sheet) => (
                <TabPane
                  tab={sheet.sheetName}
                  key={sheet.sheetName}
                  active={sheet.active}
                />
              ))}
            </TabStyled>
          </div>
        </div>
      )}
    </Styled>
  );
};

const Excel: FC<IProps> = (props: IProps) => (
  <ExcelLayout {...useExcel(props)} />
);

export default Excel;
